import { render, staticRenderFns } from "./ChangeName.vue?vue&type=template&id=4c35cc10&"
import script from "./ChangeName.vue?vue&type=script&lang=js&"
export * from "./ChangeName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports